// @ts-nocheck

import { request } from '../../../../context';
import type { ApiOptions } from '../../../../context';
import type {
    PostIntelligentCoursePartnerHomePageAdminStatisticsScoresQuery,
    PostIntelligentCoursePartnerHomePageAdminStatisticsScoresBody,
    BaseResponseIntelligentPartnerCourseHomePageAdminCourseSocresResponse,
} from '../../../../types';

/**
 * 管理员端任务详情接口
 *
 * @export
 * @tags 智能陪练课程总览接口
 * @link [POST] /intelligentCoursePartner/homePage/admin/statisticsScores
 */
export function postIntelligentCoursePartnerHomePageAdminStatisticsScores(
    data: PostIntelligentCoursePartnerHomePageAdminStatisticsScoresBody
): Promise<BaseResponseIntelligentPartnerCourseHomePageAdminCourseSocresResponse>;
export function postIntelligentCoursePartnerHomePageAdminStatisticsScores(
    data: PostIntelligentCoursePartnerHomePageAdminStatisticsScoresBody,
    options: ApiOptions<never, PostIntelligentCoursePartnerHomePageAdminStatisticsScoresQuery>
): Promise<BaseResponseIntelligentPartnerCourseHomePageAdminCourseSocresResponse>;
export function postIntelligentCoursePartnerHomePageAdminStatisticsScores(
    data: PostIntelligentCoursePartnerHomePageAdminStatisticsScoresBody,
    options?: ApiOptions<never, PostIntelligentCoursePartnerHomePageAdminStatisticsScoresQuery>
): Promise<BaseResponseIntelligentPartnerCourseHomePageAdminCourseSocresResponse> {
    return request<
        PostIntelligentCoursePartnerHomePageAdminStatisticsScoresBody,
        never,
        PostIntelligentCoursePartnerHomePageAdminStatisticsScoresQuery
    >('/intelligentCoursePartner/homePage/admin/statisticsScores', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postIntelligentCoursePartnerHomePageAdminStatisticsScores',
    });
}

export const meta = [
    {
        tags: ['智能陪练课程总览接口'],
        path: '/intelligentCoursePartner/homePage/admin/statisticsScores',
        method: 'post',
    },
];
